export default __webpack_public_path__ + "static/media/img9.2bfd864e.png";